"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActionTypeRunner = function (actionType) { return ({
    INIT: actionType + "_INIT",
    SUCCESS: actionType + "_SUCCESS",
    ERROR: actionType + "_ERROR",
}); };
